import { render } from "./ProfileNavigation.vue?vue&type=template&id=7b1f0d97&scoped=true&lang=pug"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js"

import "./ProfileNavigation.vue?vue&type=style&index=0&id=7b1f0d97&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1f0d97"]])

export default __exports__